import { ImportantButton } from 'components';
import './ExploreHelpSections.css';

const SECTIONS = [
  { key: 'cards', label: 'Cards' },
  { key: 'wordTable', label: 'Word Table' },
  { key: 'addWord', label: 'Add Word' },
];

const ExploreHelpSections = ({ currentSection, onNavigate }) => {
  const others = SECTIONS.filter((s) => s.key !== currentSection);

  return (
    <div className="explore-help-sections">
      <p className="explore-help-sections-title">Explore other sections</p>
      <div className="explore-help-sections-buttons">
        {others.map((s) => (
          <ImportantButton key={s.key} buttonText={s.label} onClick={() => onNavigate(s.key)} />
        ))}
      </div>
    </div>
  );
};

export { ExploreHelpSections };
